import Icon from '../components/Icon.vue'

Icon.register({
  lightbulb: {
    width: 352,
    height: 512,
    paths: [
      {
        d: 'M96.1 454.3l0-38.3h160l0 38.3c0 5.3-2.4 13.3-5.4 17.7l-17.1 25.7c-5.2 7.9-17.2 14.3-26.6 14.3h-61.7c-9.5 0-21.4-6.4-26.6-14.3l-17.1-25.7c-3.5-5.2-5.3-11.4-5.4-17.7zM0 176c0-93 73.4-175.7 175.4-176 97.5-0.3 176.6 78.6 176.6 176 0 44.4-16.5 84.8-43.6 115.8-16.5 18.8-42.4 58.2-52.2 91.5 0 0.3-0.1 0.5-0.1 0.8h-160.2c0-0.3-0.1-0.5-0.1-0.8-9.8-33.2-35.7-72.6-52.2-91.5-27.1-30.9-43.6-71.4-43.6-115.8zM176 96c8.8 0 16-7.2 16-16s-7.2-16-16-16c-61.8 0-112 50.2-112 112 0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.1 35.9-80 80-80z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/lightbulb.js
// module id = 1522
// module chunks = 0